import { render, staticRenderFns } from "./DeleteSelectedItemModal.vue?vue&type=template&id=3ca948a6&scoped=true"
import script from "./DeleteSelectedItemModal.vue?vue&type=script&lang=js"
export * from "./DeleteSelectedItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca948a6",
  null
  
)

export default component.exports